import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadingSpinner from "./LoadingSpinner/LoadingSpinner";
import UnauthorizedPage from "../pages/UnauthorizedPage";

export default function ProtectedRoute({
  children,
  allowedRoles = [],
  redirectTo = "/login",
  fallbackComponent = null
}) {
  const location = useLocation();
  const { user, isAuthenticated, loading } = useSelector((state) => state.auth);

  // Show loading spinner while auth is being checked
  if (loading) {
    return <LoadingSpinner />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !user) {
    return <Navigate
      to={redirectTo}
      state={{ from: location.pathname }}
      replace
    />;
  }

  // Role-based access check
  if (allowedRoles.length > 0) {
    const userRole = user.role?.toLowerCase();
    const hasPermission = allowedRoles.some(role => role.toLowerCase() === userRole);

    if (!hasPermission) {
      return fallbackComponent || <UnauthorizedPage />;
    }
  }

  return children;
}
